import { Component, OnInit,AfterViewInit,ElementRef,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http'; 
import { ApiService } from '../api.service';

declare var $: any; // Declare jQuery

@Component({
  selector: 'app-home',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  faqs: any[] = []; 
  groupedFaqs: any[] = [];
  
  constructor(
    private route: Router,
    private viewportScroller: ViewportScroller,
    private titleService: Title,
    private metaService: Meta,
    private el: ElementRef,
    private httpClient: HttpClient,
    private apiService: ApiService

    
  ) { }

  ngOnInit(): void {

        this.titleService.setTitle("Faq | Line Haul")

        const metaDesc = this.metaService.getTag('name=description'); 

        if(!metaDesc){
            this.metaService.addTags([
                {name: "description", content: "Linehaul is an organization lead by a team of highly enthusiastic individuals whom are committed, innovative and passionate in continuously adding value to our business industry. Our Vision is to be the market leader in logistic innovation, providing execution efficiency and accessibility to our customers, henceforth, carrying the Mission to constantly increase our value proposition in the context of secured, price competitiveness and haulage excellence. The company organization structure is helmed by 4 key departments in which, are supervised by industry captains whom will navigate the operation towards business excellence. The mentioned departments are Operation Excellence, Commercial (Sales & Marketing), Information System & Technology, (IS&T), Strategic Planning and Finance. In Linehaul, our team is committed and motivated towards product innovation to cater for different market segments and its demand, hence investing extensively in logistic Research & Development initiatives to sustain market dynamics and maintain our competitive advantages. Begin your business journey with us, your entrusted Logistic Partner!"}
            ]);
        }else{
            this.metaService.updateTag(  
                {name: "description", content: "Linehaul is an organization lead by a team of highly enthusiastic individuals whom are committed, innovative and passionate in continuously adding value to our business industry. Our Vision is to be the market leader in logistic innovation, providing execution efficiency and accessibility to our customers, henceforth, carrying the Mission to constantly increase our value proposition in the context of secured, price competitiveness and haulage excellence. The company organization structure is helmed by 4 key departments in which, are supervised by industry captains whom will navigate the operation towards business excellence. The mentioned departments are Operation Excellence, Commercial (Sales & Marketing), Information System & Technology, (IS&T), Strategic Planning and Finance. In Linehaul, our team is committed and motivated towards product innovation to cater for different market segments and its demand, hence investing extensively in logistic Research & Development initiatives to sustain market dynamics and maintain our competitive advantages. Begin your business journey with us, your entrusted Logistic Partner!" },  
                "name=description"  
            )  
        }
        this.loadFaq();    
  }
    
  answersVisible: { [key: string]: boolean } = {};

  toggleAnswer(answerId: string): void {
    this.answersVisible[answerId] = !this.answersVisible[answerId];
  }

   toggleTopic(topicId: number): void {
    this.faqs.forEach(topic => {
      if (topic.id === topicId) {
        topic.isExpanded = !topic.isExpanded;
      } else {
        topic.isExpanded = false;
      }
    });
  }

  loadFaq(): void {
    this.apiService.loadFaq().subscribe(
      (response) => {
        console.log('Fetched FAQ data:', response);
        this.faqs = response.faqs;
        this.groupedFaqs = this.groupFaqsByTopic(this.faqs);

      },
      error => {
        console.error('Error fetching FAQ:', error);
      }
    );
  }

  groupFaqsByTopic(faqs: any[]): any[] {
    const groupedFaqs = [];
    const topicsMap = new Map();

    faqs.forEach(faq => {
      const topic = faq.topic;

      if (!topicsMap.has(topic)) {
        topicsMap.set(topic, { topic, qaList: [] });
        groupedFaqs.push(topicsMap.get(topic));
      }

      topicsMap.get(topic).qaList.push(faq);
    });

    return groupedFaqs;
  }

}